// @flow
/* eslint-disable no-param-reassign */
import is from 'mz-utils/is'
import toPath from 'mz-utils/toPath'

function clone(obj: any) {
  if (is.object(obj)) {
    return { ...obj }
  }
  if (is.array(obj)) {
    return [...obj]
  }
  if (is.string(obj) || is.number(obj) || is.undef(obj) || is.bool(obj)) {
    return obj
  }
  throw new Error("Can't clone unkown object type")
}

export function getIn(
  obj: any,
  key: string | string[],
  def?: any,
  p: number = 0
) {
  const path = toPath(key)
  while (obj && p < path.length) {
    obj = obj[path[p++]]
  }
  return obj === undefined ? def : obj
}

export function setIn(obj: any, path: string, value: any): any {
  const res: any = clone(obj) // this keeps inheritance when obj is a class
  let resVal: any = res
  let i = 0
  const pathArray = toPath(path)

  for (; i < pathArray.length - 1; i++) {
    const currentPath: string = pathArray[i]
    const currentObj: any = getIn(obj, pathArray.slice(0, i + 1))

    if (currentObj && (is.object(currentObj) || Array.isArray(currentObj))) {
      resVal[currentPath] = clone(currentObj)
      resVal = resVal[currentPath]
    } else {
      const nextPath: string = pathArray[i + 1]
      resVal[currentPath] =
        is.number(nextPath) && Number(nextPath) >= 0 ? [] : {}
      resVal = resVal[currentPath]
    }
  }

  // Return original object if new value is the same as current
  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj
  }

  if (value === undefined) {
    delete resVal[pathArray[i]]
  } else {
    resVal[pathArray[i]] = value
  }

  // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
  if (i === 0 && value === undefined) {
    delete res[pathArray[i]]
  }

  return res
}
